export const removedDoerOnlyCustomerFeaturesDeprecatedRouteMap = {
  "/customers/:customerId/assets/bettercloud/create": "/customers/:customerId/integrate/assets/bettercloud/create",
  "/customers/:customerId/assets/zendesk/create": "/customers/:customerId/integrate/assets/zendesk/create",
};
